import {
  cloneDashboardLinks,
  cloneUserDashboardLinks,
  DEFAULT_ADMIN_QUICK_LINKS,
  DEFAULT_PAY_PERIOD,
  DEFAULT_STOCK_FORMS,
  resolveAdminQuickLinks,
  resolveUserDashboardLinks,
} from './dashboardLinks'

const DEFAULT_THEME = '#2a2971'

export function parseCompanyProperties(raw) {
  if (!raw) return {}
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
  return {}
}

export function companySettings(company) {
  const props = parseCompanyProperties(company?.properties)
  const userDashboardLinks = cloneUserDashboardLinks(props.userDashboardLinks)
  const adminQuickLinks = cloneDashboardLinks(props.adminQuickLinks, DEFAULT_ADMIN_QUICK_LINKS)
  const sectionEnabled = (key) => userDashboardLinks.find((link) => link.key === key)?.enabled !== false
  return {
    themeColor: props.themeColor || DEFAULT_THEME,
    companyLogoUrl: props.companyLogoUrl || '',
    companyAddress: props.companyAddress || '',
    companyPhone: props.companyPhone || '',
    payPeriod: { ...DEFAULT_PAY_PERIOD, ...(props.payPeriod || {}) },
    stockForms: { ...DEFAULT_STOCK_FORMS, ...(props.stockForms || {}) },
    adminQuickLinks,
    userDashboardLinks,
    dashboardSections: {
      forms: sectionEnabled('forms'),
      maintenance: sectionEnabled('maintenance'),
      safety: sectionEnabled('safety'),
      hr: sectionEnabled('hr'),
    },
  }
}

export function visibleAdminQuickLinks(settings) {
  return resolveAdminQuickLinks(settings)
}

export function visibleUserDashboardLinks(settings) {
  return resolveUserDashboardLinks(settings, settings.themeColor)
}

export function isReminderCategory(category) {
  return category === 'certification' || category === 'maintenance'
}

export function formatActivityTime(unixSeconds) {
  if (!unixSeconds) return ''
  return new Date(unixSeconds * 1000).toLocaleString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

/** Date-only display matching the legacy PHP app (no time component). */
export function formatActivityDate(value) {
  if (!value) return ''
  let date
  if (typeof value === 'number') {
    date = new Date(value * 1000)
  } else {
    const raw = String(value).trim()
    // Treat YYYY-MM-DD and ISO midnight as calendar dates in local time
    const dayMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (dayMatch) {
      date = new Date(Number(dayMatch[1]), Number(dayMatch[2]) - 1, Number(dayMatch[3]))
    } else {
      date = new Date(raw)
    }
  }
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function buildCompanyProperties(existing, patch) {
  return { ...parseCompanyProperties(existing), ...patch }
}
